import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import logoPng from './autosite logo oficial.png';

// Ensure the browser tab uses our custom logo on all devices
(() => {
  try {
    const ensureLink = (rel, sizes, type = 'image/png') => {
      const selector = sizes ? `link[rel='${rel}'][sizes='${sizes}']` : `link[rel='${rel}']`;
      let link = document.querySelector(selector);
      if (!link) {
        link = document.createElement('link');
        link.rel = rel;
        link.type = type;
        if (sizes) link.sizes = sizes;
        document.head.appendChild(link);
      }
      link.href = logoPng;
      return link;
    };
    
    // Standard favicon
    ensureLink('icon', null);
    // Different sizes for better cross-device support
    ensureLink('icon', '32x32');
    ensureLink('icon', '16x16');
    // Apple devices (iPhone, iPad)
    ensureLink('apple-touch-icon', '180x180');
    // Also set without sizes as fallback
    ensureLink('apple-touch-icon', null);
  } catch {}
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
